/**
 * 生年月日「年」セレクトの option を生成する
 *
 * 対象: <select class="js-birth-year">（CF7 定義では option 無し）
 * 範囲: 今年-16 から 今年-80 まで降順
 */
const birthYears = () => {
  const selects = document.querySelectorAll('.js-birth-year');
  if (!selects.length) return;

  const current = new Date().getFullYear();
  const start = current - 16;
  const end = current - 80;

  selects.forEach((select) => {
    // 既に生成済みならスキップ（include_blank の空 option は残す）
    if (select.dataset.yearsFilled === 'true') return;

    const fragment = document.createDocumentFragment();
    for (let year = start; year >= end; year--) {
      const option = document.createElement('option');
      option.value = String(year);
      option.textContent = String(year);
      fragment.appendChild(option);
    }
    select.appendChild(fragment);
    select.dataset.yearsFilled = 'true';
  });
};

export { birthYears };
